import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';

/**
 * Campi del form per la configurazione di un singolo gruppo tematico.
 * Utilizzato all'interno del drawer di creazione/modifica gruppo.
 */
export function MapGroupConfigInput() {
  return (
    <div>
      <FormItem label="Nome (identificativo)" name="name">
        <TextInput name="name" />
      </FormItem>
      <FormItem
        label="Etichetta"
        name="label"
        help="Testo visibile nel pannello livelli. Se vuoto, viene usato il nome."
      >
        <TextInput name="label" />
      </FormItem>
      <FormItem label="Descrizione" name="description">
        <TextInput name="description" />
      </FormItem>
      <FormItem name="expandedByDefault" label="Espanso di default">
        <CheckboxInput name="expandedByDefault">
          Il gruppo è espanso all&apos;apertura del pannello livelli
        </CheckboxInput>
      </FormItem>
    </div>
  );
}
